import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.auth.PasswordResetFinalStepModule', {
    emptypasswordError: 'Please type in your new password.',
    invalidPasswordError: 'The password you have entered does not meet the security criteria.',
    title: 'Set a new password',
    newPasswordTitle: 'Enter password',
    setPasswordButtonText: 'Set a new password',
});
